const reviews = [
  {
    id: 1,
    name: "Lepz_ Trix",
    date: "March 2026",
    text: "Amazing dive sites — we spotted sharks on both dives! The small group size made such a difference, felt like a private tour. The crew were legends and the wraps and cold beer between dives were a perfect touch. Absolutely coming back.",
    stars: 5,
  },
  {
    id: 2,
    name: "Dave Nguyen",
    date: "March 2026",
    text: "Incredible experience from start to finish. The crew made our whole family feel completely comfortable in the water — even the kids who were nervous. Knowledgeable, patient, and genuinely passionate about the reef. Highly recommend!",
    stars: 5,
  },
  {
    id: 3,
    name: "Tess Baron",
    date: "February 2026",
    text: "Really appreciated how upfront and communicative the team were during the cyclone warnings — they kept us updated by phone and text the whole time. When we finally got out on the water, our guide was incredibly informative about the reef wildlife. Five stars.",
    stars: 5,
  },
];

const trustBadges = [
  {
    icon: "ri-medal-line",
    label: "PADI Dive Centre",
    sub: "Accredited Operator",
  },
  {
    icon: "ri-shield-check-line",
    label: "Great Barrier Reef Marine Park Authority",
    sub: "Permitted Operator",
  },
  {
    icon: "ri-map-pin-2-line",
    label: "Locally Owned & Operated",
    sub: "Mission Beach, Queensland",
  },
];

function StarRating({ count = 5 }: { count?: number }) {
  return (
    <div className="flex items-center gap-0.5">
      {Array.from({ length: count }).map((_, i) => (
        <i key={i} className="ri-star-fill text-amber-400 text-sm w-4 h-4 flex items-center justify-center" />
      ))}
    </div>
  );
}

export default function SocialProof() {
  return (
    <section id="reviews" className="w-full py-24 px-6 md:px-10" style={{ backgroundColor: "#f9f7f4" }}>
      <div className="max-w-6xl mx-auto">

        {/* Section Header */}
        <div className="text-center mb-14">
          <p className="text-xs uppercase tracking-[3px] text-cyan-500 font-semibold mb-4">
            Guest Reviews
          </p>
          <h2 className="text-4xl md:text-5xl font-black text-gray-900 leading-tight mb-4">
            What Our Divers Say
          </h2>
          {/* Aggregate Rating */}
          <div className="flex items-center justify-center gap-3 mt-2">
            <StarRating count={5} />
            <span className="text-gray-700 font-semibold text-base">4.8</span>
            <span className="text-gray-400 text-sm">across 249+ Google reviews</span>
          </div>
        </div>

        {/* Review Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-12">
          {reviews.map((review) => (
            <div
              key={review.id}
              className="bg-white rounded-2xl p-7 border border-gray-100 flex flex-col gap-4"
            >
              {/* Top row: avatar + name + date */}
              <div className="flex items-start justify-between gap-3">
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 flex items-center justify-center rounded-full bg-cyan-100 text-cyan-600 font-bold text-sm shrink-0">
                    <i className="ri-user-line w-5 h-5 flex items-center justify-center" />
                  </div>
                  <div>
                    <p className="font-semibold text-gray-800 text-sm leading-tight">
                      {review.name}
                    </p>
                    <p className="text-gray-400 text-xs mt-0.5">{review.date}</p>
                  </div>
                </div>
                {/* Google G mark placeholder */}
                <div className="w-6 h-6 flex items-center justify-center shrink-0">
                  <i className="ri-google-fill text-gray-300 text-lg w-6 h-6 flex items-center justify-center" />
                </div>
              </div>

              {/* Stars */}
              <StarRating count={review.stars} />

              {/* Review text */}
              <p className="text-gray-400 text-sm leading-relaxed italic flex-1 border-l-2 border-gray-100 pl-3">
                {review.text}
              </p>
            </div>
          ))}
        </div>

        {/* Platform Badge Row */}
        <div className="flex flex-wrap items-center justify-center gap-4 mb-10">
          {/* Google Reviews Badge */}
          <div className="flex items-center gap-3 bg-white border border-gray-100 rounded-xl px-5 py-3">
            <i className="ri-google-fill text-2xl text-gray-400 w-7 h-7 flex items-center justify-center" />
            <div>
              <p className="text-xs text-gray-400 leading-none mb-0.5">Google Reviews</p>
              <div className="flex items-center gap-1.5">
                <StarRating count={5} />
                <span className="text-gray-700 font-bold text-sm">4.8</span>
              </div>
            </div>
            <span className="text-xs text-gray-400 ml-1">249 reviews</span>
          </div>

          {/* TripAdvisor Badge */}
          <div className="flex items-center gap-3 bg-white border border-gray-100 rounded-xl px-5 py-3">
            <i className="ri-award-line text-2xl text-emerald-400 w-7 h-7 flex items-center justify-center" />
            <div>
              <p className="text-xs text-gray-400 leading-none mb-0.5">TripAdvisor</p>
              <div className="flex items-center gap-1.5">
                <StarRating count={5} />
                <span className="text-gray-700 font-bold text-sm">5.0</span>
              </div>
            </div>
            <span className="text-xs text-gray-400 ml-1">Excellent</span>
          </div>
        </div>

        {/* Read More CTA */}
        <div className="flex justify-center mb-20">
          <a
            href="https://www.google.com/search?q=Mission+Beach+Dive+missionbeachdive.com.au+reviews"
            target="_blank"
            rel="noopener noreferrer"
            className="whitespace-nowrap inline-flex items-center gap-2 px-7 py-3.5 rounded-full border-2 border-gray-200 text-gray-600 font-semibold text-sm cursor-pointer hover:border-gray-400 hover:text-gray-800 transition-all duration-200"
          >
            <i className="ri-google-fill w-4 h-4 flex items-center justify-center" />
            Read More Reviews on Google
          </a>
        </div>

        {/* Trust Badge Row */}
        <div className="border-t border-gray-200 pt-12">
          <p className="text-center text-xs uppercase tracking-[3px] text-gray-400 font-medium mb-8">
            Credentials &amp; Accreditations
          </p>
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-6">
            {trustBadges.map((badge) => (
              <div
                key={badge.label}
                className="flex flex-col items-center text-center gap-3 bg-white rounded-2xl px-6 py-7 border border-gray-100"
              >
                <div className="w-12 h-12 flex items-center justify-center rounded-full bg-cyan-50 text-cyan-500">
                  <i className={`${badge.icon} text-2xl`} />
                </div>
                <div>
                  <p className="font-bold text-gray-800 text-sm leading-snug">{badge.label}</p>
                  <p className="text-gray-400 text-xs mt-1">{badge.sub}</p>
                </div>
              </div>
            ))}
          </div>

          {/* CTA after trust badges — no dead ends */}
          <div className="mt-12 text-center">
            <p className="text-gray-400 text-sm mb-5">
              Enough credentials — ready to get in the water?
            </p>
            <a
              href="https://wa.me/61455957263?text=Hi!%20I'd%20like%20to%20book%20a%20dive%20trip%20to%20Bedarra%20Island."
              target="_blank"
              rel="noopener noreferrer"
              className="whitespace-nowrap inline-flex items-center gap-2 px-8 py-4 rounded-full bg-gradient-to-r from-orange-500 to-amber-500 text-white font-bold text-sm cursor-pointer hover:scale-105 transition-transform duration-300"
              style={{ boxShadow: "0 8px 24px rgba(249,115,22,0.35)" }}
            >
              <i className="ri-ship-line w-4 h-4 flex items-center justify-center" />
              Book Your Dive Day Trip
            </a>
          </div>
        </div>

      </div>
    </section>
  );
}
